import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);

const PurchaseOrderProcessChart = ({
  data,
  title = "Purchase Order Process",
}) => {
  const chartData = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: "Completed Qty",
        data: data.map((item) => item.currentValue),
        backgroundColor: "#f48fb1",
        borderRadius: 20,
        barPercentage: 0.6,
        stack: "Stack 0",
      },
      {
        label: "Ordered Qty",
        data: data.map(
          (item) =>
            (item.fullValue || item.currentValue + (item.netValue || 0)) -
            item.currentValue
        ),
        backgroundColor: "#4dd0e1",
        borderRadius: 20,
        barPercentage: 0.6,
        stack: "Stack 0",
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: { color: "#fff" },
      },
      title: {
        display: true,
        text: title,
        color: "#fff",
        font: { size: 22 },
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "y", // Pan vertically
        },
        zoom: {
          wheel: {
            enabled: true, // Enable mouse wheel scroll
          },
          mode: "y", // Zoom vertically
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: "#fff" },
        grid: { color: "rgba(255,255,255,0.1)" },
      },
      y: {
        stacked: true,
        ticks: { color: "#fff" },
        grid: { color: "rgba(255,255,255,0.1)" },
      },
    },
  };

  return (
    <div
      style={{
        background: "#23263a",
        borderRadius: 16,
        padding: 20,
        maxWidth: 600,
        height: 315, // fixed height view
        marginTop: 30,
        marginLeft: 10,
      }}
    >
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default PurchaseOrderProcessChart;
